import { action, computed, observable, makeAutoObservable } from 'mobx';
import { MessageType } from './type';

interface ChatInterface {
    messageInput: string;
    messages: MessageType[];
    newMessageCount: number;
    isScrolled: boolean;
}

class ChatStore implements ChatInterface {
    @observable public messageInput: ChatInterface['messageInput'] = '';
    @observable public messages: ChatInterface['messages'] = [];
    @observable public newMessageCount: ChatInterface['newMessageCount'] = 0;
    @observable public isScrolled: ChatInterface['isScrolled'] = false;

    public constructor() {
        makeAutoObservable(this);
    }

    @computed
    public get getNewMessageCount(): number {
        return this.newMessageCount;
    }

    @computed
    public get getHasNewMessage(): boolean {
        return this.newMessageCount > 0;
    }

    @computed
    public get getMessageInput(): string {
        return this.messageInput;
    }

    @computed
    public get getMessages(): MessageType[] {
        return this.messages;
    }

    @computed
    public get getIsScrolled(): boolean {
        return this.isScrolled;
    }

    @action
    public setMessageInput = (message: string) => {
        this.messageInput = message;
    };

    @action
    public setIsScrolled = (flag: boolean) => {
        this.isScrolled = flag;
    };

    @action
    public addMessage = (message: MessageType) => {
        this.messages.push(message);
    };

    @action
    public setMessages = (messages: MessageType[]) => {
        this.messages = messages;
    };

    @action
    public updateNewMessageCount = () => {
        this.newMessageCount++;
    };

    @action
    public resetNewMessageCount = () => {
        this.newMessageCount = 0;
    };
}

export const chatStore = new ChatStore();
